import Vue from 'vue'
import * as moment from 'moment'

export default{
  install() {
    Vue.filter('dateTime', function(value, formatter = 'YYYY-MM-DD HH:mm:ss') {
      return moment(value).format(formatter)
    })

    Vue.filter('date', function(value, formatter = 'YYYY-MM-DD') {
      return moment(value).format(formatter)
    })

    //agv任务状态过滤器
    Vue.filter("taskStatus", function(value) {
      switch (value) {
        case 40:
          return "到达目的地";
        case 30:
          return "前往目的地";
        case 20:
          return "到达起始地";
        case 10:
          return "前往起始地";
        case -1:
          return "已撤销";
        default:
          return "无";
      }
    });

    //agv任务执行状态
    Vue.filter("taskExecStatus", function(value) {
      switch (value) {
        case 0:
          return "小车离线";
        case 1:
          return "任务空闲";
        case 2:
          return "任务执行中";
        case 3:
          return "异常告警";
        case 5:
          return "机器人暂停";
        case 7:
          return "充电状态";
        case 9:
          return "充电中(充满维护)";
        default:
          return "无";
      }
    });

    //团购状态过滤器
    Vue.filter("groupStatus", function(value) {
      switch (value) {
        case -1:
          return "已撤销";
        case 10:
          return "进行中";
        case 20:
          return "已结束（人数不足）";
        case 30:
          return "已结束（团购完成）";
        default:
          return "未开始";
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/filter/index.js